import decode from 'jwt-decode'

export function getTokenExpirationDate(token) {
    const decoded = decode(token)

    if (!decoded.exp) {
        return null
    }

    const date = new Date(0) // The 0 here is the key, which sets the date to the epoch

    date.setUTCSeconds(decoded.exp)
    return date
}

export function isTokenExpired(token) {
    const date = getTokenExpirationDate(token)

    if (date === null) {
        return false
    }
    // This wasn't explained in the docs but I believe that
    // the offsetSeconds can be set to account for time drift
    const offsetSeconds = 0
    const offsetMilliseconds = offsetSeconds * 1000

    return !(date.valueOf() > new Date().valueOf() + offsetMilliseconds)
}
